import { IconButton, Tooltip } from '@mui/material';
import { ElectricBolt as RoentgenIcon } from '@mui/icons-material';
import { useRoentgenStore } from './roentgenStore';

export const RoentgenToggle = () => {
  const toggle = useRoentgenStore((s) => s.toggle);
  const isOpen = useRoentgenStore((s) => s.drawerOpen);

  return (
    <Tooltip title={isOpen ? 'Close Roentgen' : 'Open Roentgen'}>
      <IconButton
        size="small"
        onClick={toggle}
        sx={{
          color: isOpen ? 'primary.main' : 'inherit',
          '&:hover': { color: 'primary.main' },
        }}
      >
        <RoentgenIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
};
